import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [CommonModule, MatToolbarModule, RouterModule]
})
export class FooterComponent {

  errorMenu = false;
  callcenterMenu = false;
  mobileMenu = false;
  qrMenu = false;

  constructor(
    private _router: Router
  ) {
    this._router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((e) => {
        this.checkUrlMenu(e as NavigationEnd);
    });
  }

  checkUrlMenu(e: NavigationEnd) {
    this.errorMenu = false;
    this.callcenterMenu = false;
    this.mobileMenu = false;
    this.qrMenu = false;
    if (e.urlAfterRedirects.endsWith('500')) {
      this.errorMenu = true;
    }
    if (e.urlAfterRedirects.includes('callcenter')) {
      this.callcenterMenu = true;
    }
    if (e.urlAfterRedirects.includes('mobile')) {
      this.mobileMenu = true;
    }
    if (e.urlAfterRedirects.includes('store-qr')) {
      this.qrMenu = true;
    }
  }

  goToLink(url: string) {
    window.open(url, '_blank');
  }
}
